import { AxiosProgressEvent } from "axios";
import kebabCase from "lodash.kebabcase";

import { fetcher } from "helpers/fetcher";

import {
  TUploadOrganizationImageReq,
  TUploadOrganizationImageRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const uploadOrganizationImageExterior = async (
  payload: TUploadOrganizationImageReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<
    TUploadOrganizationImageRes,
    TUploadOrganizationImageReq["data"]
  >(ENDPOINT.CORPORATION.UPLOAD_ORGANIZATION_IMAGE_EXTERIOR, {
    data: payload.data,
    fileFields: ["file"],
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPLOAD_ORGANIZATION_IMAGE_EXTERIOR.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress) onUploadProgress(progressEvent);
    },
    namingTransformer: kebabCase,
  });
};
